import { useState } from 'react';
import { Receipt } from '@/account/Interfaces';
import { useAppConfigContext } from '@/context/AppConfig';
import { CircularProgress, Icons } from '@/theme/index';
import { useReceiptPdf } from '../../useReceiptPdf/useReceiptPdf';
import { localPrintPDF } from '../utils';

export type ReceiptComponentProps = {
  /** The receipt object contains the date, transaction, payment method used, and amount. */
  receipt: Receipt;
};

/** This component is used to display the PDF receipt. */
export const ReceiptComponent = ({ receipt }: ReceiptComponentProps) => {
  const { refetch: createPDF } = useReceiptPdf([receipt.id]);
  const { logError, trackEvent } = useAppConfigContext();
  const [isLocalPrintLoading, setIsLocalPrintLoading] = useState(false);

  const printPDFHandler = () => {
    trackEvent('print', 'engagement click', 'pdf banner');
    localPrintPDF(createPDF, setIsLocalPrintLoading, logError);
  };

  return isLocalPrintLoading ? (
    <CircularProgress />
  ) : (
    <Icons.Download onClick={printPDFHandler} sx={{ cursor: 'pointer' }} />
  );
};
